import * as Components from "./Component";
import { LoginLanguage } from "../../components/UI/Dropdown";
import naayaTradeLogo from "../../assets/LoginPage/ntLogo.png"; // naayaTrade logo
import OtpInput from "./OtpInput";
import globe from "../../assets/LoginPage/globe.png";
import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  createUserWithEmailAndPassword,
  getAuth,
  signInWithEmailAndPassword,
  signOut,
  updateProfile,
} from "@firebase/auth";
import { PasswordVisibleSVG, DisablePasswordSVG, PasswordInfoSVG, RegisterSuccessSVG } from "../../assets/svg/allSvg";

import { Formik } from "formik";
import { CircularProgress } from "@mui/material";
import { commonPoint } from "../../common/Apicall";
import { UserAuthContext } from "../../App";

function LoginPage({ values, handleChange }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [forgetPswd, setForgetPswd] = useState(false);
  const [emailTab, setEmailTab] = useState(false);
  const [enterEmail, setEnterEmail] = useState(false);
  const [enterPhone, setEnterPhone] = useState(false);
  const [newPasswordTab, setNewPasswordTab] = useState(false);
  const [error, setError] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [errorOTP, setErrorOTP] = useState("");
  const [loader, setLoader] = useState(false);
  const [emailStatus, setEmailStatus] = useState("");
  const { userUid } = useContext(UserAuthContext);

  const [showPassword, setShowPassword] = useState(false);

  const [isSubmitted, setIsSubmitted] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const [showNewPassword, setShowNewPassword] = useState(false);

  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };

  const closeModal = () => {
    setIsSubmitted(false);
    // Formik.resetForm()
  };

  const options = [
    { value: "India", label: "India" },
    { value: "USA", label: "USA" },
    { value: "China", label: "China" },
    { value: "Japan", label: "Japan" },
  ];

  const SocialIcons = [
    {
      type: "Google",
      img: require("../../assets/LoginPage/Social_Icons/google.png"),
    },
    {
      type: "microsoft",
      img: require("../../assets/LoginPage/Social_Icons/microsoft.png"),
    },
    {
      type: "outlook",
      img: require("../../assets/LoginPage/Social_Icons/outlook.png"),
    },
    {
      type: "facebook",
      img: require("../../assets/LoginPage/Social_Icons/facebook.png"),
    },
  ];

  const [signIn, toggle] = React.useState(true);
  const [isWantToBeSeller, setIsWantToBeSeller] = useState(false);

  const initialValues = {
    email: "",
    password: "",
  };

  // login function
  function firebaseLogin(values) {
    if (values.email != "" && values.password != "") {
      const auth = getAuth();
      signInWithEmailAndPassword(auth, values.email, values.password)
        .then(async (userCredential) => {
          const user = userCredential.user;
          setToken(user.uid);

          if (user?.uid) navigate("/");

          return true;
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      console.log("error");
    }
  }
  const setToken = (uid) => {
    try {
      fetch(`${commonPoint}/api/v1/users/loginToken`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          document.cookie = `token=${data.token}; path=/`;
        })
        .catch((error) => console.error(error));
    } catch (e) {
      console.log(e);
    }
  };

  // signup function
  function firebaseSignup(values) {
    if (values.email != "" && values.password != "") {
      const auth = getAuth();
      createUserWithEmailAndPassword(auth, values.email, values.password)
        .then(async (userCredential) => {
          const user = userCredential.user;
          await updateProfile(user, {
            displayName: values.name,
          });

          try {
            const response = await fetch(
              `${commonPoint}/api/v1/users/register`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  uid: user.uid,
                  name: values.name,
                  email: user.email,
                  phoneNumber: values.phoneNumber,
                  gstNumber: values.gstNumber,
                  emailVerified: 0,
                  accountType: isWantToBeSeller ? "seller" : "buyer",
                }),
              }
            );

            if (isWantToBeSeller) {
              const temp = getAuth();
              const uid = temp.currentUser.uid;
              const response = await fetch(
                `${commonPoint}/api/v1/store/registerSeller`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    storeID: user.uid,

                    storeDesc: "",
                    storeLogo: "",
                    phoneNumber: values.phoneNumber,
                    storeName: values.storeName,
                    storeAddress: values.address,
                    city: values.city,
                    country: values.country,
                    state: values.state,
                    gstNumber: values.gstNumber,
                    postcode: "400050",
                    isVerified: 0,
                  }),
                }
              );

              // register response
              if (!response.ok) {
                console.error("Network response was not ok");
              }
            }

            // buyer response
            if (!response.ok) {
              console.error("Network response was not ok");
            }

            await response.json();

            // alert("Successfully register")
            setIsSubmitted(true);
            // send to login page
          } catch (error) {
            console.error("Error:", error);
          }
          await signOut(auth);
        })
        .catch((error) => {
          if (error.code === "auth/email-already-in-use") {
            setEmailStatus(
              "The email address is already in use by another account."
            );
          }
        });
    }
  }

  return (
    <>
      <div className="flex items-center justify-center h-full w-screen">

        <Components.MainContainer>
          <Components.Container>
            {isSubmitted && (
              <div className="inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 fixed z-[900]">
                <div className="bg-white rounded-[10px] w-[480px] h-[250px] flex flex-col items-center justify-center gap-y-[15px]">
                  <p className="w-[90px] h-[90px] bg-[#0097B2] rounded-full flex items-center justify-center">{RegisterSuccessSVG}</p>
                  <p className="w-[375px] h-[25px] text-black font-semibold text-[16px]">Your account has been created Successfully !</p>
                  <button onClick={closeModal} className="w-[43px] h-[38px] rounded-[5px] bg-[#FF6300] text-white flex items-center justify-center font-semibold text-[14px]">
                    OK
                  </button>
                </div>
              </div>
            )}
            <Components.SignUpContainer signinIn={signIn}>

              <Components.CreateForm>

                <div className="w-full">
                  <div className="flex items-center justify-between">
                    <div className="w-[174px] h-[27px] flex-shrink-0 mt-[13px] ml-[29px] text-[18px] font-semibold text-[#FF8100] leading-[27px] text-start select-none">
                      Registration
                    </div>
                    <p
                      className="text-[#FF8100] text-[12px] font-medium h-[44px] items-center justify-center flex pt-[15px] pr-[51px] cursor-pointer select-none"
                      onClick={() =>
                        setIsWantToBeSeller((previous) => !previous)
                      }
                    >
                      {isWantToBeSeller === true ? (
                        <p>Want To Become Buyer ?</p>
                      ) : (
                        <p>Want To Become Seller ?</p>
                      )}
                    </p>
                  </div>
                </div>
                <Formik
                  initialValues={{
                    name: "",
                    phoneNumber: "",
                    email: "",
                    password: "",
                    confirmPassword: "",
                    storeName: "",
                    gstNumber: "",
                    isAgree: false,
                    country: "",
                    state: "",
                    city: "",
                    address: "",
                  }}
                  validate={(values) => {
                    const errors = {};
                    // name
                    if (!values.name) {
                      errors.name = "Required";
                    }
                    // phoneNumber
                    if (!values.phoneNumber) {
                      errors.phoneNumber = "Required";
                    } else if (!/^\+?\d{10,15}$/i.test(values.phoneNumber)) {
                      errors.phoneNumber = "Invalid Phone Number";
                    }
                    // email
                    if (!values.email) {
                      errors.email = "Required";
                    } else if (
                      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                        values.email
                      )
                    ) {
                      errors.email = "Invalid email address";
                    }
                    // password
                    if (!values.password) {
                      errors.password = "Required";
                    } else if (
                      !/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/i.test(
                        values.password
                      )
                    ) {
                      errors.password = "Invalid password pattern ";
                    }
                    // confirmPassword
                    if (!values.confirmPassword) {
                      errors.confirmPassword = "Required";
                    } else if (values.password !== values.confirmPassword) {
                      errors.confirmPassword =
                        "Password and Confirm password does not match !";
                    }
                    // gstNumber
                    if (!values.gstNumber) {
                      errors.gstNumber = "Required";
                    } else if (
                      !/^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/i.test(
                        values.gstNumber
                      )
                    ) {
                      errors.gstNumber = "Invalid GST Number";
                    }

                    if (!values.isAgree) {
                      errors.isAgree =
                        "You must agree to the terms and conditions";
                    }

                    return errors;
                  }}
                  onSubmit={async (values, { setSubmitting }) => {
                    try {
                      firebaseSignup(values);
                    } catch (err) {
                      console.log("Firebase error");
                    }
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    // resetForm,
                    isSubmitting,
                  }) => (
                    <div>
                      <div className="flex gap-x-[45px] w-full pl-[29px] mt-[10px]">
                        <div className="flex flex-col float-start ml-0 text-left w-[240px]">
                          <p className="text-[14px] font-medium w-[45px] h-[21px] text-black">
                            Name
                          </p>
                          <input
                            name="name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.name}
                            className="w-[240px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                            placeholder="Enter your name"
                          />
                          {errors.name && (
                            <p className="text-red-600 text-[12px]">
                              {errors.name}
                            </p>
                          )}
                        </div>

                        <div className="flex flex-col float-start ml-0 text-left w-[240px]">
                          <p className="text-[14px] font-medium w-[109px] h-[21px] text-black">
                            Phone Number
                          </p>
                          <input
                            maxLength={10}
                            name="phoneNumber"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.phoneNumber}
                            className="w-[240px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                            placeholder="Enter your phone number"
                          />
                          {errors.phoneNumber && (
                            <p className="text-red-600 text-[12px]">
                              {errors.phoneNumber}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="flex flex-col float-start pl-[29px] text-left w-full mt-[5px]">
                        <p className="text-[14px] font-medium w-[109px]  text-black">
                          Email
                        </p>
                        <input
                          name="email"
                          onChange={(text) => {
                            handleChange(text);
                            setEmailStatus("");
                          }}
                          onBlur={handleBlur}
                          value={values.email}
                          className="w-[526px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                          placeholder="Enter your Email ID"
                        />
                        {errors.email && (
                          <p className="text-red-600 text-[12px]">
                            {errors.email}
                          </p>
                        )}
                      </div>

                      <div className="flex gap-x-[45px] w-full pl-[29px] mt-[10px]">
                        <div className="flex flex-col float-start ml-0 text-left w-[240px]">
                          <div className="w-[100px] items-center flex h-[22px]">
                            <p className="text-[14px] font-medium w-[72px] text-black">
                              Password
                            </p>
                            {PasswordInfoSVG}
                          </div>

                          <div className="relative w-[240px]">
                            <input
                              name="password"
                              type={showNewPassword ? "text" : "password"}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.password}
                              className="w-full h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                              placeholder="Set Password"
                            />
                            <button
                              type="button"
                              onClick={toggleNewPasswordVisibility}
                              className={`absolute inset-y-0 right-0 flex items-center px-2 text-sm font-medium ${showNewPassword ? 'text-[#9E9E9E]' : 'text-[#9E9E9E]'}`}
                            >
                              {showNewPassword ? DisablePasswordSVG : PasswordVisibleSVG}
                            </button>
                          </div>

                          {errors.password && (
                            <p className="text-red-600 text-[12px]">
                              {errors.password}
                            </p>
                          )}
                        </div>

                        <div className="flex flex-col float-start ml-0 text-left w-[240px]">
                          <p className="text-[14px] font-medium w-[134px] text-black">
                            Confirm Password
                          </p>
                          <input
                            name="confirmPassword"
                            type="password"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.confirmPassword}
                            className="w-[240px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                            placeholder="Confirm your Password"
                          />
                          {errors.confirmPassword && (
                            <p className="text-red-600 text-[12px]">
                              {errors.confirmPassword}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="flex gap-x-[45px] w-full pl-[29px] mt-[5px]">
                        <div className="flex flex-col float-start ml-0 text-left w-[240px]">
                          <div className="flex items-center">
                            <p className="text-[14px] font-medium w-[88px] h-[21px] text-black">
                              Store Name
                            </p>
                            {isWantToBeSeller === false && (
                              <span className="text-[#B3B3B3] text-[12px] font-medium w-[70px] h-[18px]">
                                ( Optional )
                              </span>
                            )}
                          </div>
                          <input
                            name="storeName"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.storeName}
                            className="w-[240px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                            placeholder="Enter your Store name"
                          />
                          {errors.storeName && (
                            <p className="text-red-600 text-[12px]">
                              {errors.storeName}
                            </p>
                          )}
                          {isWantToBeSeller === true ? (
                            <div>
                              <p className="text-[10px] font-normal w-[220px] h-[15px] text-black mt-[4px]">
                                https://naayatrade.com/store/{values.storeName}
                              </p>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>

                        <div className="flex flex-col float-start ml-0 text-left w-[240px]">
                          <div className="flex items-center">
                            <p className="text-[14px] font-medium w-[93px] h-[21px] text-black">
                              GST Number
                            </p>
                          </div>
                          <input
                            name="gstNumber"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.gstNumber}
                            className="w-[240px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                            placeholder="Enter your 15 Digit GST number"
                          />
                          {errors.gstNumber && (
                            <p className="text-red-600 text-[12px]">
                              {errors.gstNumber}
                            </p>
                          )}
                        </div>
                      </div>

                      {isWantToBeSeller === true && (
                        <>
                          <div className="flex mt-[5px] w-full pl-[29px] gap-x-[17px]">
                            <div className="flex flex-col ml-0 text-left w-[164px]">
                              <p className="text-[14px] font-medium w-[59px] text-black">
                                Country
                              </p>
                              <select
                                className="w-[163px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                name="country" // Make sure the name matches the field name in initialValues
                                value={values.country} // Set the value from Formik's state
                                onChange={handleChange} // Call handleChange to update Formik's state
                              >
                                <option className="text-[#B3B3B3]" value="">
                                  Select Country
                                </option>
                                {options.map((option) => (
                                  <option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="col-start-4 col-end-7">
                              <div className="flex flex-col float-start ml-0 text-left w-[164px]">
                                <p className="text-[14px] font-medium w-[59px] text-black">
                                  State
                                </p>
                                <select
                                  className="w-[163px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                  name="state"
                                  value={values.state}
                                  onChange={handleChange}
                                >
                                  <option className="text-[#B3B3B3]" value="">
                                    Select State
                                  </option>
                                  {options.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-start-7 col-end-13">
                              <div className="flex flex-col float-start ml-0 text-left w-[164px]">
                                <p className="text-[14px] font-medium w-[59px] text-black">
                                  City
                                </p>
                                <select
                                  className="w-[163px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                  name="city"
                                  value={values.city}
                                  onChange={handleChange}
                                >
                                  <option className="text-[#B3B3B3]" value="">
                                    Select City
                                  </option>
                                  {options.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="flex flex-col float-start pl-[29px] text-left w-full mt-[5px]">
                            <p className="text-[14px] font-medium w-[109px] h-[21px] text-black">
                              Address
                            </p>
                            <textarea
                              name="address"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.address}
                              rows="2"
                              maxlength="150"
                              className="w-[526px] h-[55px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3] resize-none"
                              placeholder="Enter Company Address"
                            />
                          </div>
                        </>
                      )}

                      <div className="flex pt-[10px] w-[548px] gap-x-[12px] ml-[29px] ">
                        <label>
                          <input
                            name="isAgree"
                            className="h-[20px] w-[20px]"
                            type="checkbox"
                            value={values.isAgree}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </label>
                        <p className="text-[12px] pr-[10px] font-medium text-left w-[500px]">
                          I Agree To Terms & Conditions I agree to
                          <span className="text-[#FF6300]">
                            {" "}
                            (a) Terms Of Use{" "}
                          </span>
                          and
                          <span className="text-[#FF6300]">
                            {" "}
                            (b) Privacy Policy.
                          </span>{" "}
                          I agree to receive more information from
                          Naayatrade.com about its products and services.
                        </p>
                      </div>
                      {errors.isAgree && (
                        <p className="text-red-600 text-[12px]">
                          {errors.isAgree}
                        </p>
                      )}
                      {emailStatus && (
                        <p className="text-red-600 text-[12px]">
                          {emailStatus}
                        </p>
                      )}

                      <div className="w-full flex items-center justify-center">
                        {!loader ? (
                          <button
                            type="submit"
                            // onClick={handleSubmit}
                            // onClick={() => {
                            //   handleSubmit(); // Trigger form submission
                            //   // resetForm(); // Reset the form
                            // }}
                            onClick={handleSubmit}
                            className="text-white bg-[#FF6300] w-[130px] h-[48px] rounded-[10px] mt-[15px] flex items-center justify-center"
                          >
                            <p className="w-[70px] h-[25px] font-semibold text-[16px]">
                              Register
                            </p>
                          </button>
                        ) : (
                          <button className="register-button text-white bg-[#FF6300] w-[130px] h-[48px] rounded-[10px] mt-[15px] flex items-center justify-center">
                            <CircularProgress color="inherit" size={24} />
                          </button>
                        )}
                      </div>


                    </div>
                  )}
                </Formik>

                {isWantToBeSeller === false && (
                  <>
                    <div className="flex h-[21px] items-center justify-center gap-x-[29px] mt-[42px] w-[504px]">
                      <hr className="w-[123px] h-[1px] bg-[#E9E9E9]" />
                      <p className="text-black text-[14px] font-medium">
                        Or Sign In With
                      </p>
                      <hr className="w-[123px] h-[1px] bg-[#E9E9E9]" />
                    </div>

                    <div className="w-full h-[60px] gap-x-[18px] mt-[20px] flex items-center justify-center">
                      {SocialIcons.map((items, i) => {
                        return (
                          <div key={i}>
                            <button>
                              <div className="w-[40px] h-[40px] rounded-full bg-white flex-shrink-0 fill-[#fff] drop-shadow-[0_0px_2px_rgba(0,0,0,0.25)] flex items-center justify-center">
                                <img
                                  src={items.img}
                                  className="w-[26px] h-[26px]"
                                  alt="Social_Icons"
                                />
                              </div>
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}
              </Components.CreateForm>
            </Components.SignUpContainer>

            <Components.SignInContainer signinIn={signIn}>
              <Link to="/" className="w-full h-[130px]">
                <img
                  src={naayaTradeLogo}
                  alt="naayatrade"
                  className="w-[191px] h-[55px] ml-[75px] mt-[35px]"
                />
              </Link>

              {forgetPswd ? (
                // ForgetPassword or RecoverySection
                <div className="h-[491px] w-[504px] bg-[#FFFFFF] rounded-[10px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] border">
                  {newPasswordTab ? (
                    <Formik
                      initialValues={{
                        newPassword: "",
                        confirmNewPassword: "",
                      }}
                      validate={(values) => {
                        const errors = {};
                        if (!values.newPassword) {
                          errors.newPassword = "new password required";
                        }

                        if (!values.confirmNewPassword) {
                          errors.confirmNewPassword =
                            "confirm password required";
                        } else if (
                          values.newPassword !== values.confirmNewPassword
                        ) {
                          errors.confirmNewPassword = "Passwords do not match";
                        }

                        return errors;
                      }}
                      onSubmit={async (values) => {
                        const data = {
                          email,
                          newPassword: values.newPassword,
                        };
                      }}
                    >
                      {({
                        values,
                        errors,
                        handleChange,
                        handleSubmit,
                        isSubmitting,
                      }) => (
                        <div className="newPasswordTab">
                          <div className="text-[#FF6300] text-center text-[18px] font-semibold w-full h-[27px] mt-[25px]">
                            Reset Password
                          </div>
                          <div className="mt-[43px] pl-[29px] flex flex-col">
                            <div className="flex flex-col float-start ml-0 text-left ">
                              <div className=" items-center flex ">
                                <p className="text-[14px] font-medium text-black">
                                  New Password
                                </p>
                              </div>
                              <input
                                value={values.newPassword}
                                onChange={handleChange}
                                type="password"
                                name="newPassword"
                                className="input-txt w-[438px] h-[30px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-[500] placeholder-[#B3B3B3]"
                                placeholder="Set New Password"
                              />
                              {errors.newPassword && (
                                <p className="text-red-600 text-[12px]">
                                  {errors.newPassword}
                                </p>
                              )}
                            </div>
                            <div className="flex flex-col float-start ml-0 text-left w-[240px] mt-[30px]">
                              <div className="items-center flex h-[22px]">
                                <p className="text-[14px] font-medium text-black">
                                  Confirm New Password
                                </p>
                              </div>
                              <input
                                type="password"
                                name="confirmNewPassword"
                                value={values.confirmNewPassword}
                                onChange={handleChange}
                                className="input-txt w-[438px] h-[30px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-[500] placeholder-[#B3B3B3]"
                                placeholder="Confirm New Password"
                              />
                              {errors.confirmNewPassword && (
                                <p className="text-red-600 text-[12px]">
                                  {errors.confirmNewPassword}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="w-full flex items-center justify-center">
                            <button
                              onClick={handleSubmit}
                              type="submit"
                              className="register-button w-[190px] h-[48px] bg-[#FF6300] rounded-[10px] text-white font-[600] text-[16px] mt-[73px]"
                            >
                              Change Password
                            </button>
                          </div>
                        </div>
                      )}
                    </Formik>
                  ) : (
                    <div className="recoveryMethod">
                      <div className="text-[#FF6300] text-center text-[18px] font-semibold w-full h-[27px] mt-[25px]">
                        Choose a recovery method
                      </div>

                      <div className="items-center mt-[43px]">
                        <div className="emailTab col-start-1 col-end-13 h-[24px] text-center ">
                          {/* col-start-1 col-end-7 w-[250px]*/}
                          <button
                            onClick={() => {
                              setEmailTab(false);
                            }}
                            className=" h-[24] text-[16px] font-semibold text-center text-black"
                          >
                            {/* w-[46px] */}
                            Email
                          </button>
                          {!emailTab && (
                            <div className="w-[250px] ml-[38%] mr-auto h-[4px]  items-center justify-center mt-[18px]">
                              {/* flex */}
                              <hr className="border-t border-[4px] border-[#FF8100] w-[119px] rounded-full" />
                            </div>
                          )}
                        </div>
                        <div className="passwordtab w-[250px] text-center">
                          {/* col-start-7 col-end-13 */}
                          <button
                            onClick={() => {
                              setEmailTab(false); //setEmailTab(true) for Phone Number functionality
                            }}
                            className="w-[150px] h-[24] text-[16px] font-semibold text-center text-black hidden"
                          >
                            {/* remove hidden css For Phone Number visibility */}
                            Phone Number
                          </button>
                          {emailTab && (
                            <div className="w-[250px] h-[4px] flex items-center justify-center mt-[18px]">
                              <hr className="border-t border-[4px] border-[#FF8100] w-[182px] rounded-full" />
                            </div>
                          )}
                        </div>
                      </div>
                      {emailTab ? (
                        <div className="phone-tab mt-[36px]">
                          {enterPhone ? (
                            <>
                              <div className="w-full flex items-center justify-center">
                                <p className="text-[14px] font-medium w-[289px] h-[50px] text-center">
                                  Enter the 4 Digit OTP that is sent on your
                                  Phone number.
                                </p>
                              </div>
                              <div className="flex items-center justify-center flex-col float-start ml-0 text-left w-full">
                                <div className="w-[438px] mt-[20px]">
                                  <p className="text-[14px] font-semibold text-black leading-[21px]">
                                    Enter OTP
                                  </p>
                                  <OtpInput
                                    otp={otp}
                                    setOtp={setOtp}
                                    className="rounded-[5px] border-[1px] mt-[15px] py-[4px] text-[14px] font-semibold w-[58px] h-[50px]"
                                  />
                                  <div className="w-full flex items-center justify-center">
                                    <button
                                      type="Submit"
                                      className="register-button w-[160px] h-[48px] bg-[#FF6300] rounded-[10px] text-white font-[600] text-[16px] mt-[73px]"
                                    >
                                      Verify OTP
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="enter-phone">
                                <p className="text-[14px] font-medium mx-[63px] text-center">
                                  Enter your phone number to receive an OTP for
                                  account access.
                                </p>
                                <div className="flex mt-[20px] items-center flex-col float-start ml-0 text-left w-full">
                                  <p className="text-[14px] text-start font-semibold w-[456px] h-[21px] text-black leading-[21px]">
                                    Phone Number
                                  </p>
                                  <input
                                    className="w-[456px] h-[29px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                    placeholder="Enter your phone number"
                                  />
                                  <div className="bottom-div flex justify-center w-full h-[48px] mt-[105px]">
                                    <button
                                      type="Submit"
                                      onClick={() => {
                                        setEnterPhone((prev) => !prev);
                                      }}
                                      className="register-button w-[160px] h-[48px] bg-[#FF6300] rounded-[10px] text-white font-semibold text-[16px]"
                                    >
                                      Get OTP
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      ) : (
                        <div className="email-tab mt-[36px] text-center">
                          {enterEmail ? (
                            <div className="reset-done">
                              <div className="w-full flex items-center justify-center">
                                <p className="text-[14px] font-medium w-[289px] h-[50px] text-center">
                                  Enter the 4 Digit OTP that is sent to your
                                  Email.
                                </p>
                              </div>
                              <div className="flex items-center justify-center flex-col float-start ml-0 text-left w-full">
                                <div className="w-[438px] mt-[20px]">
                                  <p className="text-[14px] font-semibold text-black leading-[21px]">
                                    Enter OTP
                                  </p>
                                  <OtpInput
                                    otp={otp}
                                    setOtp={setOtp}
                                    className="rounded-[5px] border-[1px] mt-[15px] py-[4px] text-[14px] font-semibold w-[58px] h-[50px]"
                                  />
                                  {errorOTP && (
                                    <div className="text-red-600 text-[12px] mt-1">
                                      {errorOTP}
                                    </div>
                                  )}
                                  <div className="w-full flex items-center justify-center">
                                    {!loader ? (
                                      <button
                                        type="Submit"
                                        className="register-button w-[160px] h-[48px] bg-[#FF6300] rounded-[10px] text-white font-[600] text-[16px] mt-[73px]"
                                      >
                                        Verify OTP
                                      </button>
                                    ) : (
                                      <button className="register-button w-[160px] h-[48px] bg-[#FF6300] rounded-[10px] text-white font-[600] text-[16px] mt-[73px]">
                                        <CircularProgress
                                          color="inherit"
                                          size={24}
                                        />
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="enter-email">
                              <p className="text-[14px] font-medium mx-[63px] w-[378px] h-[50px] text-center mt-[63px]">
                                Enter your Email to receive an OTP to Reset your
                                Password.
                              </p>
                              <div className="flex flex-col items-center justify-center float-start text-left w-full mt-[16px]">
                                <p className="text-[14px] text-start font-semibold w-[438px] h-[21px] text-black leading-[21px]">
                                  Email
                                </p>
                                <input
                                  onChange={(e) => {
                                    setErrorEmail("");
                                    setEmail(e.target.value);
                                  }}
                                  className="w-[438px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                  placeholder="Enter your Email ID"
                                />
                              </div>
                              {errorEmail && (
                                <div className="pl-[34px] pt-2 text-[12px] text-red-600 text-left">
                                  {errorEmail}
                                </div>
                              )}
                              <div className="bottom-div justify-center w-[100%]">
                                {!loader ? (
                                  <button
                                    type="Submit"
                                    className="register-button w-[160px] h-[48px] bg-[#FF6300] rounded-[10px] text-white font-semibold text-[16px] mt-[100px]"
                                  >
                                    Send OTP
                                  </button>
                                ) : (
                                  <button className="register-button w-[160px] h-[48px] bg-[#FF6300] rounded-[10px] text-white font-semibold text-[16px] mt-[100px]">
                                    <CircularProgress
                                      color="inherit"
                                      size={24}
                                    />
                                  </button>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                // LoginForm
                <div className="h-[491px] w-[504px] bg-[#FFFFFF] rounded-[10px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] border flex items-start justify-start flex-col">
                  <Formik
                    initialValues={initialValues}
                    validate={(values) => {
                      const errors = {};
                      if (!values.email) {
                        errors.email = "Email Required";
                      } else if (
                        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                          values.email
                        )
                      ) {
                        errors.email = "Invalid email address";
                      }

                      if (!values.password) {
                        errors.password = "Password Required";
                      }

                      setError("");
                      return errors;
                    }}
                    onSubmit={async (values, { setSubmitting }) => {
                      try {
                        firebaseLogin(values);
                        // navigate("/");
                      } catch (err) {
                        console.log("Firebase error");
                      }
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleSubmit,
                    }) => (
                      <div className="w-[504px] flex flex-col">
                        <p className="w-[474px] ml-[30px] h-[27px] flex-shrink-0 mt-[17px] text-[18px] font-semibold text-[#FF8100] leading-[27px] text-start">
                          Log In
                        </p>

                        <div className="flex flex-col items-center justify-center float-start text-left w-full mt-[20px]">
                          <p className="text-[14px] font-medium w-full pl-[32px] h-[21px] flex items-start text-black">
                            Email ID / Phone Number
                          </p>
                          <input
                            className="w-[438px] h-[31px] rounded-[5px] border-[1px] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                            placeholder="Enter your Email ID"
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                          />
                        </div>
                        <p className="ml-[34px]  text-[#FF6300] text-[12px]">
                          {errors.email && touched.email && errors.email}
                        </p>
                        <div className="flex flex-col items-center justify-center float-start ml-0 text-left w-full mt-[30px]">
                          <div className="w-full pl-[32px] items-center flex h-[22px]">
                            <p className="text-[14px] font-medium w-[72px] h-[21px] text-black">
                              Password
                            </p>
                            <svg
                              width="13"
                              height="12"
                              viewBox="0 0 13 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g id="Info">
                                <g id="Layer 2">
                                  <path
                                    id="Vector"
                                    d="M6.5 1.5C5.53582 1.5 4.59329 1.76392 3.7916 2.25839C2.98991 2.75285 2.36507 3.45566 1.99609 4.27792C1.62711 5.10019 1.53057 6.00499 1.71867 6.87791C1.90678 7.75082 2.37108 8.55264 3.05286 9.18198C3.73464 9.81132 4.60328 10.2399 5.54894 10.4135C6.49459 10.5872 7.47479 10.4981 8.36558 10.1575C9.25637 9.81686 10.0177 9.24009 10.5534 8.50007C11.0891 7.76005 11.375 6.89002 11.375 6C11.375 4.80653 10.8614 3.66193 9.94715 2.81802C9.03291 1.97411 7.79293 1.5 6.5 1.5ZM6.5 9.75C5.69652 9.75 4.91107 9.53007 4.243 9.11801C3.57492 8.70596 3.05422 8.12029 2.74674 7.43506C2.43926 6.74984 2.35881 5.99584 2.51556 5.26841C2.67231 4.54098 3.05923 3.8728 3.62738 3.34835C4.19553 2.8239 4.9194 2.46675 5.70745 2.32206C6.4955 2.17736 7.31233 2.25162 8.05465 2.53545C8.79698 2.81928 9.43145 3.29993 9.87785 3.91661C10.3242 4.5333 10.5625 5.25832 10.5625 6C10.5625 6.99456 10.1345 7.94839 9.37262 8.65165C8.61076 9.35491 7.57744 9.75 6.5 9.75Z"
                                    fill="#231F20"
                                    stroke="black"
                                    strokeWidth="0.5"
                                  />
                                  <path
                                    id="Vector_2"
                                    d="M6.49983 5.13749C6.39208 5.13749 6.28875 5.177 6.21256 5.24733C6.13638 5.31765 6.09358 5.41303 6.09358 5.51249V8.06249C6.09358 8.16195 6.13638 8.25733 6.21256 8.32766C6.28875 8.39798 6.39208 8.43749 6.49983 8.43749C6.60757 8.43749 6.7109 8.39798 6.78709 8.32766C6.86328 8.25733 6.90608 8.16195 6.90608 8.06249V5.51249C6.90608 5.41303 6.86328 5.31765 6.78709 5.24733C6.7109 5.177 6.60757 5.13749 6.49983 5.13749ZM6.49983 3.59999C6.38985 3.60381 6.28563 3.64635 6.20857 3.71888C6.1315 3.79141 6.08745 3.88842 6.08545 3.98999V4.04999C6.08526 4.09892 6.0961 4.14735 6.11729 4.19219C6.13848 4.23704 6.16956 4.27733 6.20853 4.31048C6.24751 4.34364 6.29354 4.36894 6.34369 4.38478C6.39384 4.40063 6.44701 4.40666 6.49983 4.40249C6.60629 4.39878 6.7073 4.35808 6.78263 4.28854C6.85796 4.219 6.90206 4.12576 6.90608 4.02749V3.93749C6.9064 3.88983 6.89578 3.84265 6.87492 3.79905C6.85406 3.75545 6.82343 3.71642 6.78505 3.68454C6.74667 3.65265 6.70141 3.62864 6.65225 3.61406C6.60309 3.59949 6.55114 3.59469 6.49983 3.59999Z"
                                    fill="#231F20"
                                    stroke="black"
                                    strokeWidth="0.5"
                                  />
                                </g>
                              </g>
                            </svg>
                          </div>

                          <div className="relative w-[438px] h-[31px] mt-[5px]">
                            <input
                              type={showPassword ? "text" : "password"}
                              className="w-full h-full rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                              placeholder="Enter Password"
                              name="password"
                              value={values.password}
                              onChange={handleChange}
                            />
                            <button
                              type="button"
                              onClick={togglePasswordVisibility}
                              className={`absolute inset-y-0 right-0 flex items-center px-2 text-sm font-medium ${showPassword ? 'text-[#9E9E9E]' : 'text-[#9E9E9E]'}`}
                            >
                              {showPassword ? DisablePasswordSVG : PasswordVisibleSVG}
                            </button>
                          </div>
                        </div>
                        <p className="ml-[34px] text-[#FF6300] text-[12px]">
                          {errors.password &&
                            touched.password &&
                            errors.password}
                        </p>
                        {error && (
                          <div className="pl-[34px] mt-2 text-[12px] text-red-600">
                            {error}
                          </div>
                        )}

                        <div className="flex items-center justify-center mt-[9px]">
                          <button
                            type="button"
                            onClick={() => {
                              setForgetPswd((prev) => !prev);
                            }}
                            className="text-[14px] font-medium w-[438px] h-[21px] text-black text-end"
                          >
                            Forgot Password ?
                          </button>
                        </div>

                        <div className="w-full flex items-center justify-center">
                          {!loader ? (
                            <button
                              type="submit"
                              className="text-white bg-[#FF6300] font-semibold w-[130px] h-[48px] rounded-[10px] mt-[31px]"
                              onClick={handleSubmit}
                            >
                              Log In
                            </button>
                          ) : (
                            <button className="register-button text-white bg-[#FF6300] font-semibold w-[130px] h-[48px] rounded-[10px] mt-[31px]">
                              <CircularProgress color="inherit" size={24} />
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                  </Formik>

                  <div className="flex h-[21px] items-center justify-center gap-x-[29px] mt-[42px] w-[504px]">
                    <hr className="w-[123px] h-[1px] bg-[#E9E9E9]" />
                    <p className="text-black text-[14px] font-medium">
                      Or Sign In With
                    </p>
                    <hr className="w-[123px] h-[1px] bg-[#E9E9E9]" />
                  </div>

                  <div className="w-full h-[60px] gap-x-[18px] mt-[20px] flex items-center justify-center">
                    {SocialIcons.map((items, i) => {
                      return (
                        <div key={i}>
                          <button>
                            <div className="w-[40px] h-[40px] rounded-full bg-white flex-shrink-0 fill-[#fff] drop-shadow-[0_0px_2px_rgba(0,0,0,0.25)] flex items-center justify-center">
                              <img
                                src={items.img}
                                className="w-[26px] h-[26px]"
                                alt="Social_Icons"
                              />
                            </div>
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
                // End LoginForm
              )}
            </Components.SignInContainer>

            <Components.OverlayContainer signinIn={signIn}>
              <Components.Overlay signinIn={signIn}>
                <Components.LeftOverlayPanel
                  signinIn={signIn}
                  className="relative"
                >
                  <img
                    src={globe}
                    alt="globe"
                    className="absolute bottom-0 left-0 w-[660px] h-[550px]"
                  />
                  <div className="relative w-full">
                    <div className="flex items-start justify-start w-full cursor-pointer">
                      {LoginLanguage}
                    </div>
                    <div className="flex flex-col items-center justify-center">
                      <Components.Circle></Components.Circle>
                      <Components.WelcomeTitle>
                        Welcome to
                      </Components.WelcomeTitle>
                      <Components.NaayaTradeTag>
                        Naayatrade
                      </Components.NaayaTradeTag>
                      <Components.Account>
                        Already Have An Account ?
                      </Components.Account>
                      <Components.SignInButton onClick={() => toggle(true)}>
                        Sign In
                      </Components.SignInButton>
                    </div>
                  </div>
                </Components.LeftOverlayPanel>

                <Components.SignUpPanel signinIn={signIn} className="relative">
                  <img
                    src={globe}
                    alt="globe"
                    className="absolute bottom-0 left-0 w-[660px] h-[550px]"
                  />
                  <div className="relative w-full">
                    <div className="flex items-end justify-end w-full ">
                      {LoginLanguage}
                    </div>

                    <div className="flex flex-col items-center justify-center">
                      <Components.Circle></Components.Circle>
                      <Components.WelcomeTitle>
                        Welcome to
                      </Components.WelcomeTitle>
                      <Components.NaayaTradeTag>
                        Naayatrade
                      </Components.NaayaTradeTag>
                      <Components.Account>
                        Dont have an account ?
                      </Components.Account>
                      <Components.SignUpButton onClick={() => toggle(false)}>
                        <p className="w-[100px] h-[24px]">Sign Up</p>
                      </Components.SignUpButton>
                    </div>
                  </div>
                </Components.SignUpPanel>
              </Components.Overlay>
            </Components.OverlayContainer>
          </Components.Container>
        </Components.MainContainer>
      </div>
    </>
  );
}

export default LoginPage;
